import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FS } from '../shared/constants/firestorePaths';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

export async function fetchOfficeProfile() {
  const ref = collection(db, ...FS.clients(appId));
  const q = query(ref, where('isOfficeProfile', '==', true), limit(1));
  const snap = await getDocs(q);
  return snap.empty ? null : { id: snap.docs[0].id, ...(snap.docs[0].data() || {}) };
}
